import { render } from "./blockquote.vue?vue&type=template&id=2e9f8d2f&ts=true"
import script from "./blockquote.vue?vue&type=script&lang=ts"
export * from "./blockquote.vue?vue&type=script&lang=ts"

import "./blockquote.vue?vue&type=style&index=0&id=2e9f8d2f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__